import { render } from "./person-military-list.vue?vue&type=template&id=c9f5bd5e"
import script from "./person-military-list.vue?vue&type=script&lang=js"
export * from "./person-military-list.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__